import { API } from '../Client';
import { Account, Parent } from './types';

namespace AccountService {
  /**
   * Fetches user's (child's) account information from firebase
   *
   * @returns
   */
  export async function getAccount(): Promise<Account> {
    const res = await API.get('/user/me');
    return res?.data;
  }

  /**
   * Fetches parent information of current user (child)
   * @returns
   */
  export async function getParent(): Promise<Parent> {
    const res = await API.get('/user/parent');
    return res?.data;
  }
}

export default AccountService;
